// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    POSTDATE_MAIN_CONTAINER: 'postdate_main_container',
};
export const defaultAttributes = {};
export const sampleAttributes = {
    DATEUPDATE: false,
    DATE: 'June 22, 2021',
};
